var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(_vm.curStatus === 2),expression:"curStatus === 2"}],attrs:{"type":"warning"}},[_vm._v("近效期")]),_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(_vm.curStatus === 3),expression:"curStatus === 3"}],attrs:{"type":"danger"}},[_vm._v("已过期")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }